<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title">
                <span
                  >นโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท วีเสิร์ฟโก เอเซีย
                  จำกัด</span
                >
              </h2>
              <div>
                <small>ฉบับปรับปรุงข้อมูล : 1 มิถุนายน 2565</small>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-text-center">
              <nav aria-label="breadcrumb" class="blog-bradcrumb ">
                <ol class="breadcrumb bg-transparent mb-0">
                  <li class="breadcrumb-item"><a :href="'/'">Home</a></li>
                  <li class="breadcrumb-item active"><a href="#">Policy</a></li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->

      <!-- sign in -->
      <section>
        <div class="innerpage-decor">
          <div class="innerpage-circle1">
            <img src="@/assets/images/Testimonial2.png" alt="" />
          </div>
          <div class="innerpage-circle2">
            <img src="@/assets/images/Testimonial2.png" alt="" />
          </div>
        </div>
        <!--faq in -->
        <div class="faq">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div role="tablist" id="accordion">
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ข้อกำหนดการใช้บริการ </span>
                    </div>

                    <div class="card-body">
                      <p>
                        กรุณาอ่านเงื่อนไขและข้อตกลงนี้โดยละเอียด
                        หากคุณไม่ยอมรับหรือไม่เห็นด้วยกับเงื่อนไขและข้อตกลงตามนโยบายความเป็นส่วนตัวนี้
                        กรุณาปฎิเสธการเข้าใช้แพลตฟอร์มของบริษัท
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ขอบเขตและวัตถุประสงค์ของประกาศนี้</span>
                    </div>

                    <div class="card-body">
                      <p>
                        <b>บริษัท วีเสิร์ฟโก เอเซีย จำกัด</b> หรือ “บริษัท”
                        ตระหนักถึงความสำคัญในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลธรรมดาที่ซื้อสินค้าหรือใช้บริการ
                        (“ลูกค้า”) ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
                        2562
                        บริษัทจึงได้พิจารณาอนุมัตินโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท
                        ดังนั้นบริษัทจึงได้จัดทำประกาศฉบับนี้ขึ้นซึ่งครอบคลุมถึงลูกค้าทุกคน
                        โดยมีวัตถุประสงค์เพื่ออธิบายวิธีการเก็บรวบรวม ใช้
                        และเปิดเผยข้อมูลส่วนบุคคลของลูกค้าในส่วนที่เกี่ยวกับการให้สินค้าหรือใช้บริการใดๆ
                        ของบริษัท
                        โปรดอ่านเอกสารฉบับนี้เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่บริษัทได้เก็บรวบรวม
                        ใช้ และเปิดเผยข้อมูลส่วนบุคคลของลูกค้าตามประกาศนี้
                        “ข้อมูลส่วนบุคคล” หมายถึง
                        ข้อมูลเกี่ยวกับลูกค้าซึ่งทำให้สามารถระบุตัวลูกค้าได้ไม่ว่าทางตรงหรือทางอ้อมโดยไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม
                        ข้อมูลนิติบุคคล
                        หรือข้อมูลที่ได้ผ่านกระบวนการทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวลูกค้าที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
                        “ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)”
                        หมายถึง ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์
                        ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา
                        ซึ่งกระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการประกาศกำหนดซึ่งบริษัทจะเก็บรวบรวม
                        ใช้
                        และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อบริษัทได้รับความยินยอมโดยชัดแจ้งจากท่าน
                        “การประมวลผลข้อมูลส่วนบุคคล” หมายถึง
                        การดำเนินการใดๆของบริษัทต่อข้อมูลส่วนบุคคลของลูกค้ารวมถึง
                        การเก็บ รวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล
                        และการลบข้อมูลส่วนบุคคล
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ผู้ที่ใช้ข้อมูลส่วนบุคคลของลูกค้า</span>
                    </div>

                    <div class="card-body">
                      <p>
                        บริษัทเป็น “ผู้ควบคุมข้อมูลส่วนบุคคล” ของลูกค้าทุกคน
                        จึงมีหน้าที่และความรับผิดชอบต่อการประมวลผลและการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของลูกค้า
                        การประมวลผลข้อมูลส่วนบุคคลจะกระทำเท่าที่จำเป็นแก่การให้บริการเพื่อดำเนินการตามคำขอ
                        ซึ่งอาจรวมถึงการส่งเสริมการขาย การทำการตลาดแล้วแต่กรณี
                        โดยมีวัตถุประสงค์ ขอบเขต และวิธีการใช้ตามที่กฎหมายกำหนด
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >ข้อมูลส่วนบุคคลของลูกค้าที่บริษัทอาจเก็บรวบรวม</span
                      >
                    </div>

                    <div class="card-body">
                      <p>
                        ในการเข้าถึงและใช้บริการของบริษัทจำเป็นที่ลูกค้าต้องให้ข้อมูลส่วนบุคคลที่ทำให้สามารถระบุตัวตนของลูกค้าเพื่อให้สามารถระบุเกี่ยวกับสินค้าหรือใช้บริการ
                        ซึ่งบริษัทเก็บรวบรวมข้อมูลส่วนบุคคลจากลูกค้าโดยตรงข้อมูลดังกล่าวรวมถึงข้อมูลส่วนบุคคลที่ได้ระบุในระบบฐานข้อมูล
                        เช่น ชื่อ สกุล วันเดือนปีเกิด เบอร์โทรศัพท์ ที่อยู่
                        ไลน์ไอดี Internet Protocol (IP)
                        หรือข้อมูลอื่นในทำนองเดียวกัน
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >เหตุใดบริษัทต้องใช้ข้อมูลส่วนบุคคลของลูกค้า
                      </span>
                    </div>

                    <div class="card-body">
                      <p>
                        บริษัทใช้ข้อมูลส่วนบุคคลของลูกค้าเพื่อการดำเนินการทั้งหลายตามวัตถุประสงค์ของบริษัทที่เกี่ยวข้องกับการซื้อสินค้าและการให้บริการหลังการขาย
                        โดยบริษัทประมวลผลข้อมูลส่วนบุคคลของลูกค้าด้วยเหตุผล
                        (ฐานในการประมวลผลข้อมูล)
                      </p>
                      <p>
                        ซึ่งอาจจะอาศัยเหตุผลใดเหตุผลหนึ่งหรือหลายเหตุผล
                        ประกอบกันก็ได้ดังนี้
                      </p>

                      <ul style="list-style: circle">
                        <li>
                          เพราะบริษัทมีหน้าที่ปฏิบัติตามสัญญา:ประมวลผลตามฐานสัญญาซื้อขาย
                          (Contract) เพื่อให้ลูกค้าสามารถใช้สิทธิในการแลกเปลี่ยน
                          คืน หรือการใช้บริการหลังการขายตามนโยบายของบริษัท
                        </li>
                        <li>
                          เพราะบริษัทได้รับความยินยอมจากลูกค้า:ประมวลผลตามความยินยอม
                          (Consent)
                          โดยบริษัทจะขอความยินยอมจากลูกค้าในการประมวลผลข้อมูลส่วนบุคคคลของลูกค้าเพื่อวัตถุประสงค์ทางการตลาด
                          การส่งเสริมการขาย หรือเพื่อการสถิติ ศึกษา วิเคราะห์
                          วิจัย ประเมินผลข้อมูล หรือเพื่อวัตถุประสงค์ใดๆ
                          ที่ไม่ต้องห้ามตามกฎหมาย
                        </li>
                      </ul>
                      <p>
                        การประมวลผลข้อมูลส่วนบุคคลของลูกค้าจะเป็นไปตามวัตถุประสงค์ที่ได้แจ้งไว้เท่านั้น
                        ในบางกรณีบริษัทอาจพิจารณาว่าสามารถประมวลผลข้อมูลส่วนบุคคลของลูกค้าตามวัตถุประสงค์อื่นที่เกี่ยวข้องและไม่ขัด
                        หรือนอกเหนือไปจากวัตถุประสงค์เดิม
                        แต่ในกรณีที่บริษัทจำเป็นต้องประมวลผลข้อมูลด้วยวัตถุประสงค์อื่นที่ไม่เกี่ยวข้องกับวัตถุประสงค์เดิม
                        บริษัทจะขอความยินยอมใหม่เพื่อการใช้ข้อมูลตามวัตถุประสงค์ใหม่นั้น
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">
                        การขอความยินยอมจากผู้เยาว์ คนไร้ความสามารถ
                        และคนเสมือนไร้ความสามารถ
                      </span>
                    </div>

                    <div class="card-body">
                      <ul style="list-style: circle">
                        <li>
                          ผู้เยาว์ที่มีอายุไม่เกิน 10 ปี
                          ให้ขอความยินยอมจากผู้ปกครองที่มีอำนาจกระทำการแทนผู้เยาว์
                          ผู้เยาว์ที่ยังไม่บรรลุนิติภาวะสามารถให้ความยินยอมโดยลำพังได้
                          หากเข้าข่ายตามมาตราที่ 22, 23 และ 24
                          ของประมวลกฎหมายแพ่งและพาณิชย์
                          นอกเหนือจากนั้นให้ขอความยินยอมจากผู้ปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ประกอบด้วย
                        </li>
                        <li>
                          คนไร้ความสามารถ
                          ให้ขอความยินยอมจากผู้อนุบาลที่มีอำนาจกระทำการแทนคนไร้ความสามารถ
                        </li>
                        <li>
                          คนเสมือนไร้ความสามารถ
                          ให้ขอความยินยอมจากผู้พิทักษ์ที่มีอำนาจกระทำการแทนคนเสมือนไร้ความสามารถ
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การเปิดเผยข้อมูลส่วนบุคคลให้แก่บุคคลภายนอก
                      </span>
                    </div>

                    <div class="card-body">
                      <p>
                        บริษัทอาจทำการเปิดเผยข้อมูลส่วนบุคคลของลูกค้าให้แก่บุคคลภายนอกเท่าที่จำเป็นเพื่อการประมวลผลข้อมูลตามหน้าที่ความรับผิดชอบตามสัญญาหรือตามกฎหมาย
                        หรือตามที่ได้รับความยินยอมจากลูกค้า ทั้งนี้
                        เว็บไซต์และบัญชีชำระเงิน
                        อาจให้ลิงก์เชื่อมโยงไปยังเว็บไซต์และการบริการอื่น
                        เพื่อความสะดวกและให้ข้อมูลแก่ท่าน
                        ซึ่งอาจมีประกาศและนโยบายความเป็นส่วนตัวที่แตกต่างจากของบริษัท
                        ทางบริษัทแนะนำให้ท่านตรวจสอบก่อนที่จะใช้งานการบริการเหล่านั้น
                        ตามขอบเขตที่บริษัทไม่ได้เป็นเจ้าของหรือควบคุมเว็บไซต์ที่ถูกลิงก์ไปซึ่งลูกค้าเข้าเยี่ยมชมนั้น
                        บริษัทจะไม่รับผิดชอบการบริการนั้นๆ
                        วิธีการและข้อมูลที่เกี่ยวข้องกับการชำระเงินเพื่อซื้อสินค้าบนเว็บไซต์
                        ข้อมูลบัตรเครดิตของท่าน เช่น เลขที่บัตรเครดิต
                        ธนาคารที่ออกบัตรเครดิต วันหมดอายุ
                        จะถูกจัดเก็บและถูกตรวจสอบผ่านทางระบบชำระเงินผ่านบุคคลที่สาม
                        ซึ่งข้อมูลเหล่านี้จะไม่ถูกจัดเก็บอยู่ถาวรในเซิร์ฟเวอร์ของบริษัท
                        และจะถูกลบทันทีหลังจากผ่านระบบการตรวจสอบโดยระบบชำระเงินของบุคคลที่สาม
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">สิทธิในข้อมูลส่วนบุคคลของลูกค้า </span>
                    </div>

                    <div class="card-body">
                      <p>
                        ลูกค้ามีสิทธิในข้อมูลส่วนบุคคลของลูกค้าโดยลูกค้าสามารถขอใช้สิทธิต่างๆ
                        ได้ภายใต้ข้อกำหนดของกฎหมาย
                        และประกาศที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต
                        ดังต่อไปนี้
                      </p>
                      <ul style="list-style: circle">
                        <li>
                          สิทธิได้รับการแจ้งให้ทราบ (Right to be informed)
                          โดยได้รับการแจ้งเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคล
                          วิธีการเก็บรวบรวม บุคคลที่จะได้รับข้อมูล
                          เหตุผลและระยะเวลาที่จัดเก็บข้อมูลส่วนบุคคล
                        </li>
                        <li>
                          สิทธิในการเข้าถึง (Right of Access)
                          โดยสามารถขอรับสำเนาข้อมูลส่วนบุคคลของลูกค้าที่อยู่ในความรับผิดชอบของบริษัท
                          และตรวจสอบว่าบริษัทได้ประมวลผลข้อมูลตามกฎหมายหรือไม่
                        </li>
                        <li>
                          สิทธิขอให้โอนข้อมูลส่วนบุคคล (Right to data
                          portability)
                          บริษัทได้จัดทำข้อมูลส่วนบุคคลในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ
                          และประมวลผลด้วยวิธีการอัตโนมัติ
                          ลูกค้าสามารถขอให้บริษัทส่งหรือโอนข้อมูลส่วนบุคคลไปยังบุคลอื่นได้ด้วยวิธีการอัตโนมัติ
                          หรือขอรับข้อมูลส่วนบุคคลที่บริษัทส่งหรือโอนไปยังบุคคลอื่นโดยตรง
                          เว้นแต่โดยสภาพทางเทคนิคไม่สามารถทำได้
                        </li>
                        <li>
                          สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (Right to
                          object)
                          ลูกค้าสามารถคัดค้านในกรณีที่บริษัทประมวลผลข้อมูลของลูกค้า
                        </li>
                        <li>
                          สิทธิขอให้ลบหรือทำลาย
                          หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลได้
                          (Right to erasure Right to be forgotten)
                          ลูกค้าสามารถขอให้ลบข้อมูล หรือทำลาย
                          หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวตนลูกค้า
                        </li>
                        <li>
                          สิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคล (Right to
                          restrict processing)
                          ลูกค้าสามารถขอให้ระงับการใช้ข้อมูลส่วนบุคคลได้
                          เมื่อบริษัทอยู่ในระหว่างการตรวจสอบตามที่ลูกค้าขอให้แก้ไขข้อมูลส่วนบุคคล
                          หรือเมื่อบริษัทอยู่ในระหว่างการพิสูจน์ หรือตรวจสอบ
                          ตามคำขอใช้สิทธิในการคัดค้านของลูกค้า
                        </li>
                        <li>
                          สิทธิในการแก้ไขข้อมูลส่วนบุคคล (Right of
                          rectification) ลูกค้าสามารถขอแก้ไขข้อมูลให้ถูกต้อง
                          สมบูรณ์ และเป็นปัจจุบันได้
                          หากลูกค้าพบว่าข้อมูลของลูกค้าไม่ถูกต้อง สมบูรณ์
                          และเป็นปัจจุบัน
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">การถอนความยินยอม</span>
                    </div>

                    <div class="card-body">
                      <p>
                        หากลูกค้าประสงค์จะถอนความยินยอมในการประมวลผลดังกล่าว
                        สามารถติดต่อบริษัทและแจ้งความประสงค์ได้โดยทำเป็นหนังสือ
                        การถอนความยินยอมจะไม่ส่งผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมแก่บริษัทก่อนหน้าแล้วโดยชอบด้วยกฎหมาย
                        ทั้งนี้การถอนความยินยอมอาจส่งผลกระทบต่อลูกค้าในการสินค้าและบริการของบริษัท
                        เช่น ไม่ได้รับการแจ้งสิทธิประโยชน์
                        โปรโมชั่นหรือข้อเสนอใหม่ๆ
                        หรือไม่ได้รับข้อมูลข่าวสารอันเป็นประโยชน์แก่ท่าน เป็นต้น
                        ดังนั้น
                        เพื่อประโยชน์ของลูกค้าจึงควรศึกษาหรือสอบถามถึงผลกระทบก่อนเพิกถอนความยินยอม
                      </p>
                      <p>
                        หากลูกค้าถอนความยินยอมบริษัทจะใช้ความพยายามอย่างดีที่สุดที่จะดำเนินการหรือชี้แจงภายใน
                        30 วัน หรือไม่เกินตามระยะเวลาที่กฎหมายกำหนด
                        โดยบริษัทจะปฏิบัติตามข้อกำหนดทางกฎหมายที่เกี่ยวข้องกับสิทธิของลูกค้าในฐานะเจ้าของข้อมูลส่วนบุคคล
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ระยะเวลาในการจัดเก็บข้อมูลส่วนบุคคล </span>
                    </div>

                    <div class="card-body">
                      <p>
                        ตามหลักการจัดเก็บข้อมูลส่วนบุคคลเท่าที่จำเป็น
                        บริษัทจะจัดเก็บข้อมูลส่วนบุคคลของท่านเป็นระยะเวลาเท่าที่จำเป็นตามวัตถุประสงค์การเก็บรวบรวมข้อมูลตามกฎหมาย
                        ซึ่งข้อมูลส่วนบุคคลของลูกค้าจะถูกเก็บรวบรวมไว้ไม่เกิน 5
                        ปีนับจากวันที่ลูกค้าซื้อสินค้าหรือใช้บริการครั้งล่าสุด
                        เมื่อพ้นระยะเวลาจัดเก็บทางบริษัทจะทำการลบหรือทำลายข้อมูลส่วนบุคคลเพื่อความปลอดภัยของข้อมูลลูกค้า
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >วิธีการที่บริษัทใช้ในการคุ้มครองข้อมูลส่วนบุคคลของลูกค้า
                      </span>
                    </div>

                    <div class="card-body">
                      <p>
                        บริษัทจะดำเนินการให้มั่นใจได้ว่าข้อมูลส่วนบุคคลที่เก็บรวบรวมโดยบริษัทหรือในนามของบริษัทจะได้รับการจัดเก็บอย่างเหมาะสม
                        โดยผ่านการเข้ารหัสข้อมูลและมีมาตรการรักษาความปลอดภัยที่เพียงพอต่อการคุ้มครองการประมวลผลข้อมูลส่วนบุคคล
                        บริษัทอาจจะใช้คุ้กกี้
                        หรือเทคโนโลยีอื่นใดในการเก็บข้อมูลเพื่อช่วยเหลือและอำนวยความสะดวกเพื่อการเข้าถึงการบริการได้ดีขึ้น
                        เร็วขึ้น และมีความเป็นส่วนตัวมากขึ้น
                      </p>
                      <p>
                        ทั้งนี้บริษัทคำนึงถึงความไว้วางใจของลูกค้าในการให้เราปกป้องข้อมูลส่วนบุคคล
                        บริษัทจะดำเนินการตามขั้นตอนที่เหมาะสมทุกประการ
                        รวมทั้งการดูแลปกป้องด้านกายภาพ การบริหารจัดการ
                        และทางด้านเทคนิค
                        เพื่อช่วยปกป้องข้อมูลส่วนตัวอย่างดีที่สุด
                        โดยบริษัทขอแนะนำให้ทลูกค้าอย่าเปิดเผยรหัสผ่านให้ใครทราบเพื่อป้องกันการเข้าถึงระบบโดยไม่พึงประสงค์และปกป้องข้อมูลส่วนตัว
                      </p>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การแก้ไขเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล
                      </span>
                    </div>

                    <div class="card-body">
                      <p>
                        บริษัทอาจมีการพิจารณาทบทวนประกาศการคุ้มครองข้อมูลส่วนบุคคลของลูกค้าได้
                        โดยหากมีการเปลี่ยนแปลง
                        บริษัทจะแจ้งให้ทราบบนเว็บไซต์ของบริษัทฯ
                        และตามช่องทางที่จะได้แจ้งให้ทราบตามความเหมาะสมต่อไป
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""> วิธีการติดต่อบริษัท </span>
                    </div>

                    <div class="card-body">
                      <p>
                        ในกรณีที่ลูกค้าประสงค์จะใช้สิทธิ
                        หรือถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลของลูกค้า
                        หรือมีข้อสงสัยเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของบริษัทสามารถติดต่อได้ที่:
                      </p>
                      <ul>
                        <li>โทรศัพท์: 02-105-4632</li>
                        <li>อีเมล: info@weservego.asia</li>
                      </ul>
                    </div>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""> การร้องเรียน </span>
                    </div>

                    <div class="card-body">
                      <p>
                        หากลูกค้าเห็นว่าการประมวลผลข้อมูลส่วนบุคคลของลูกค้าไม่เป็นไปตาม
                        พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                        ลูกค้ามีสิทธิที่จะร้องเรียนไปยังสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- faq up -->
      </section>
      <!-- sign up -->
      <!--blog Section end-->
    </div>
    <!--Footer Section start-->
    <Footer />
    <js />
    <!--Footer Section End-->
  </div>
</template>
<script>
export default {
  name: 'PDPA Policy',
};
</script>

<style scoped>
.card-body p {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
  font-size: inherit;
}

.card-body ul {
  list-style: circle;
}
</style>



// WEBPACK FOOTER //
// src/pages/policies/pdpa.vue